/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ActionMountSheet = core.serialization.object({
    slugs: core.serialization.list(core.serialization.string()).optional(),
});
